// import { isMobile } from 'react-device-detect';
import snakeCaseKeys from 'snakecase-keys';
import ApiBase from './ApiBase';
import { getAuthToken } from '../../shared/auth';
// import MockApi from './__mocks__/Api';

class Api {
  static async postLogin(values) {
    return await ApiBase.post('auth/login', values);
  }
  static async getPlayerSettings() {
    return await ApiBase.get('players/setting', {}, Api.jwtHeader());
  }
  static async getChapterList() {
    return await ApiBase.get('players/chapter_list', {}, Api.jwtHeader());
  }
  static async putPlayer(values) {
    return await ApiBase.put('players', snakeCaseKeys(values), Api.jwtHeader());
  }

  static jwtHeader() {
    return { Authorization: `Bearer ${getAuthToken()}` };
  }
}

// export default process.env.NODE_ENV === 'local' ? MockApi : Api;
export default Api;
